const variantAnalysis = {
  title: "Variant Analysis Documentation",

  fields: [
    {
      title: "Project Name",
      description:
        "Provide a meaningful and unique name for your Variant Analysis project. This name will be used to identify the analysis throughout the platform.",

      examples: [
        "Breast_Cancer_Variants",
        "Patient_001_VariantAnalysis",
        "Familial_Mutation_Study",
      ],

      notes: [
        "Choose a descriptive project name.",
        "Avoid using unnecessary special characters.",
        "The project name will appear in your dashboard and reports.",
      ],
    },

    {
      title: "Number of Samples",
      description:
        "Enter the total number of samples included in this analysis. Credits will be calculated automatically based on the number of samples.",

      examples: [
        "1",
        "5",
        "20",
      ],

      notes: [
        "Must be greater than zero.",
        "Ensure the number matches the uploaded samples.",
      ],
    },

    {
      title: "Short Notes",
      description:
        "Provide additional information about your study or any special analysis requirements that may assist the bioinformatics team.",

      examples: [
        "Germline variant analysis.",
        "Whole genome sequencing samples.",
      ],

      notes: [
        "Optional field.",
        "Include any special instructions if required.",
      ],
    },

    {
      title: "Raw Data Source",
      description:
        "Specify how your sequencing data will be provided for analysis.",

      examples: [
        "Online",
        "Offline",
      ],

      notes: [
        "For Online, provide the download link to your sequencing files.",
        "Username and password can be provided if the link is protected.",
        "If Offline is selected, our team will contact you regarding the data transfer process.",
      ],
    },

    {
      title: "Organism",
      description:
        "Search and select the organism corresponding to your sequencing data. Start typing at least three characters to view matching organisms.",

      notes: [
        "Choose the organism that matches your sequencing experiment.",
        "Selecting the correct organism ensures accurate reference alignment and variant identification.",
      ],
    },

    {
      title: "Alignment Tool",
      description:
        "Select the alignment tool used to map sequencing reads to the selected reference genome.",

      examples: [
        "BWA",
        "Bowtie2",
      ],

      notes: [
        "The selected aligner affects mapping performance and downstream variant calling.",
        "Choose the aligner appropriate for your sequencing workflow.",
      ],
    },

    {
      title: "Metadata Builder",
      description:
        "Provide a unique Sample ID for each sequencing sample included in the analysis. Sample IDs are used throughout the workflow and final reports.",

      examples: [
        "Sample_001",
        "Patient_A01",
        "Control_01",
      ],

      notes: [
        "At least one Sample ID is required.",
        "Each Sample ID must be unique.",
        "Click 'Add Sample' to add additional samples.",
        "Click 'Save Metadata' after completing all Sample IDs.",
        "Use 'Modify Metadata' if changes are required later.",
      ],
    },

    {
      title: "Raw Data QC Parameters",

      description:
        "Configure quality control parameters used to filter sequencing reads before variant calling.",

      sections: [
        {
          title: "Phred Quality Score",

          description:
            "Defines the minimum acceptable base quality score during quality filtering.",

          notes: [
            "Allowed range: 10–40.",
            "Default value: 30.",
            "Higher values perform stricter quality filtering.",
          ],
        },

        {
          title: "Minimum Read Length Required",

          description:
            "Specifies the minimum read length that must remain after trimming for a read to be retained.",

          notes: [
            "Allowed range: 50–120 bases.",
            "Default value: 75 bases.",
            "Reads shorter than the specified length will be discarded.",
          ],
        },
      ],
    },
  ],
};

export default variantAnalysis;